var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6437 9.59364C11.4754 8.86065 12 7.78749 12 6.5918C12 4.38266 10.2091 2.5918 8 2.5918C5.79086 2.5918 4 4.38266 4 6.5918C4 7.78749 4.52463 8.86065 5.35627 9.59364C2.38513 9.66986 0 12.1023 0 15.0918V18.0918C0 18.3679 0.223858 18.5918 0.5 18.5918H15.5C15.7761 18.5918 16 18.3679 16 18.0918V15.0918C16 12.1023 13.6149 9.66986 10.6437 9.59364Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 15.0918C31 12.1787 29.0838 9.71333 26.4429 8.88721C26.7987 8.19986 27 7.41915 27 6.5918C27 3.83037 24.7614 1.5918 22 1.5918C19.2386 1.5918 17 3.83037 17 6.5918C17 7.41915 17.2013 8.19986 17.5571 8.88721C14.9162 9.71333 13 12.1787 13 15.0918V18.0918C13 18.9202 13.6716 19.5918 14.5 19.5918H29.5C30.3284 19.5918 31 18.9202 31 18.0918V15.0918Z",
    fill: "currentColor",
    stroke: "#1D1F52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.866682d9.svg";
export { ForwardRef as ReactComponent };